export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'training4' as string
export const OVERSIGHT_ENV_NAME = 'oversight-training'
export const GCS_ENV_NAME = 'training4'
export const SUBDOMAIN_SUFFIX = 'gcs-training'
